// extracted by mini-css-extract-plugin
export default {"overlay":"new-modal__overlay--LXHRd"};